/** お知らせマスタ画面 */
export const INFORMATION_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'information',
  // 対象テーブル
  TARGET_TABLE: 'information',
};
